export default "__VITE_ASSET__CQCG4WaO__"